<p-dialog [blockScroll]="true" [draggable]="false"header="Edit Item" [(visible)]="displayDialog" [modal]="true" [responsive]="true" dir="rtl">
    <form (ngSubmit)="saveItem()" class="p-fluid">
      <div class="p-field">
        <label class="ms-label-view" for="name">{{"name"| translator}}</label>
        <input class="ms-border ms-input-view" type="text" id="name" pInputText [(ngModel)]="selectedItem.name" name="name">
      </div>
      <div class="p-field">
        <label class="ms-label-view" for="table">{{"Table"| translator}}</label>
        <input class="ms-border ms-input-view" type="text" id="table" pInputText [(ngModel)]="selectedItem.table" name="table">
      </div>
      <div class="p-field">
        <label class="ms-label-view" for="graphname">{{"The name of the graph"| translator}}</label>
        <input class="ms-border ms-input-view" type="text" id="graphname" pInputText [(ngModel)]="selectedItem.graphname" name="graphname">
      </div>
      <div class="p-field">
        <label class="ms-label-view" for="graphtype">{{"Graph"| translator}}</label>
        <input class="ms-border ms-input-view" type="text" id="graphtype" pInputText [(ngModel)]="selectedItem.graphtype" name="graphtype">
      </div>
      <div class="p-field ppp-textarea">
        <label class="ms-label-view my-3" for="aggregation">{{"Assembly"| translator}}</label>
        <textarea class="ms-input-view" [(ngModel)]="jsonData" appJsonValidator class="p-inputtext" [style]="{'width':'100%'}"></textarea>
        <div *ngIf="jsonData && jsonData.errors && jsonData.errors.invalidJson" class="validation-error">JSON {{"not good"| translator}}</div>
      </div>
      <div class="p-dialog-footer">
        <button type="button" pButton icon="pi pi-times" label='{{"Cancellation"| translator}}' (click)="hideDialog()"></button>
        <button type="submit" pButton icon="pi pi-check" label='{{"Save"| translator}}'></button>
      </div>
    </form>
  </p-dialog>
